import { IconsProps } from 'Icons/types'
import React from 'react'

const Calendar = ({ fill = '#0d0d0d' }: IconsProps) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.00002 1.25C8.41423 1.25 8.75002 1.58579 8.75002 2V3.24997H15.25V2C15.25 1.58579 15.5858 1.25 16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V3.24997H19C20.5188 3.24997 21.75 4.48118 21.75 5.99997V20C21.75 21.5187 20.5188 22.75 19 22.75H5C3.48122 22.75 2.25 21.5187 2.25 20V5.99997C2.25 4.48118 3.48122 3.24997 5 3.24997H7.25002V2C7.25002 1.58579 7.5858 1.25 8.00002 1.25ZM7.25002 4.74997H5C4.30964 4.74997 3.75 5.30961 3.75 5.99997V9.24997H20.25V5.99997C20.25 5.30961 19.6904 4.74997 19 4.74997H16.75V6C16.75 6.41421 16.4142 6.75 16 6.75C15.5858 6.75 15.25 6.41421 15.25 6V4.74997H8.75002V6C8.75002 6.41421 8.41423 6.75 8.00002 6.75C7.5858 6.75 7.25002 6.41421 7.25002 6V4.74997ZM20.25 10.75H3.75V20C3.75 20.6903 4.30964 21.25 5 21.25H19C19.6904 21.25 20.25 20.6903 20.25 20V10.75Z'
        fill={fill}
      />
    </svg>
  )
}

export default Calendar
